export enum PoolStatus {
  EXPIRED = 'EXPIRED',
  FULLY_ALLOCATED = 'FULLY_ALLOCATED',
  NOT_STARTED = 'NOT_STARTED',
  ONGOING = 'ONGOING',
  TERMINATED = 'TERMINATED',
}
